import React from 'react';
import { useTranslation } from 'react-i18next';

export const GtinInfo = () => {
  const { t } = useTranslation();

  return (
    <>
      {t('epdWizard.wizardStep2.info.gtin.gtin1')}&nbsp;
      <a href="https://www.gs1.org/standards/id-keys/gtin" target="_blank" rel="noopener noreferrer">
        Global Trade Item Number
      </a>
      &nbsp;
      {t('epdWizard.wizardStep2.info.gtin.gtin2')}
    </>
  );
};
